import React from "react";
import injectSheet from "react-jss";

const styles = (theme) => ({
  badge: {
    position: "absolute",
    padding: "1px",
    minWidth: (props) => (props.small ? "12px" : "15px"),
    minHeight: (props) => (props.small ? "12px" : "17px"),
    lineHeight: (props) => (props.small ? "1" : null),
    left: "-10px",
    top: "-17px",
    borderRadius: (props) => (props.small ? "50%" : "2px"),
    textAlign: "center",
    backgroundColor: (props) =>
      props.color ? props.color : theme.messageBadgeColor,
    boxShadow: "-1px 1px 2px 0 rgba(0, 0, 0, 0.2)",
    fontSize: "11px",
    letterSpacing: "0.4px",
    fontWeight: "bold",
  },
  "@media (max-width: 767px)": {},
});
const Messagebadge = injectSheet(styles)(
  ({ classes, children, id }) =>
    children && (
      <span id={id} style={{ position: "relative" }}>
        <span id={id} className={classes.badge}>
          {children}
        </span>
      </span>
    )
);

export default Messagebadge;
